import React from 'react';
import Header from '@/components/header';
import LoginComponent from '@/components/Login';
import { SafeAreaView } from 'react-native-safe-area-context';

export default function Login() {
  return (
    <SafeAreaView style={{ width:'100%', flex: 1, margin:0, padding: 0 }}>
      <Header />
      <LoginComponent />
    </SafeAreaView>
  );
}